import React from 'react'
import { List, Datagrid, TextField, EditButton, Filter, TextInput, Responsive, SimpleList } from 'react-admin'
import { TableRowList, ListActions } from '../../../components'

const PostionsFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput className={props.classes.input} variant="filled" label="Name" source="name" alwaysOn fullWidth />
    </Filter>
  )
}

const Actions = (props) => {
  return <ListActions {...props} filters={<PostionsFilter />} />
}

const ProceduresList = (props) => (
  <List bulkActions={false} title="Procedures" {...props} actions={<Actions />}>
    <Responsive
      small={<SimpleList primaryText={(record) => record.name} />}
      medium={
        <Datagrid>
          <TextField source="name" label="Name" />
          <TableRowList>
            <EditButton />
          </TableRowList>
        </Datagrid>
      }
    />
  </List>
)

export default ProceduresList
